import dayjs from 'dayjs';

import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

import DynamicList from 'components/list/DynamicList';
import { FilterAction, FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, REPORT } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const AggregatorAgingShipments = () => {
	const location = useLocation();
	const defaultSort = useMemo(() => [{ id: 'shipmentCreatedDate', desc: true }], []);

	const columns = useMemo(
		() => [
			{
				Header: 'deliveryCompany',
				accessor: 'deliveryCompanyName',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.DELIVERY_COMPANIES,
				showOnMobile: true
			},
			{
				Header: 'DCSettingName',
				accessor: 'deliveryCompanySettingsName',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.DELIVERY_COMPANY_SETTINGS_FOR_AGGREGATORS_WITH_OMNI,
				showOnMobile: true
			},
			{
				Header: 'delayType',
				accessor: 'delayType',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.DELAY_TYPE,
				showOnMobile: true
			},
			{
				Header: 'agingOfDays',
				accessor: 'agingDays',
				filterType: FilterType.float
			},
			{
				Header: 'orderID',
				accessor: 'orderId',
				filterType: FilterType.string,
				showCopyButton: true,
				showOnMobile: true
			},
			{
				Header: 'shipmentNumber',
				accessor: 'shipmentNumber',
				filterType: FilterType.string,
				showCopyButton: true
			},
			{
				Header: 'maxTier',
				accessor: 'maxTier',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.PRICE_CONFIGURATION_TIER_TYPE
			},
			{
				Header: 'clientName',
				accessor: 'clientName',
				filterType: FilterType.string
			},
			{
				Header: 'originCity',
				accessor: 'originCity',
				filterType: FilterType.string
			},
			{
				Header: 'originCountry',
				accessor: 'originCountry',
				filterType: FilterType.string
			},
			{
				Header: 'destinationCity',
				accessor: 'destinationCity',
				filterType: FilterType.string
			},
			{
				Header: 'destinationCountry',
				accessor: 'destinationCountry',
				filterType: FilterType.string
			},
			{
				Header: 'pickupId',
				accessor: 'pickupId',
				filterType: FilterType.number,
				showCopyButton: true,
				showOnMobile: true
			},
			{
				Header: 'shipmentCreatedDate',
				accessor: 'shipmentCreatedDate',
				filterType: FilterType.date,
				width: 170,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'pickupDate',
				accessor: 'pickupDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'agreementType',
				accessor: 'agreementType',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.SHIPPING_PRICE_AGREEMENT_TYPE
			},
			{
				Header: 'pickUpSLATime',
				accessor: 'pickUpSLATime',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'deliverySLATime',
				accessor: 'deliverySLATime',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'transferDuration',
				accessor: 'transferDuration',
				filterType: FilterType.float
			},
			{
				Header: 'contactName',
				accessor: 'contactName',
				filterType: FilterType.string
			},
			{
				Header: 'serviceType',
				accessor: 'serviceType',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.PRICE_CONFIGURATION_SERVICE_TYPE
			},
			{
				Header: 'shipmentFlow',
				accessor: 'shipmentFlow',
				enumName: ENUMS.SHIPMENT_FLOW,
				filterType: FilterType.enumMulti
			},
			{
				Header: 'otoId',
				accessor: 'otoId',
				filterType: FilterType.string
			},
			{
				Header: 'status',
				accessor: 'status',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.ALL_STATUSES,
				renderCell: ListComponents.SHIPMENT_STATUS,
				renderCellProps: {
					ID: 'otoId',
					orderID: 'otoId'
				},
				showOnMobile: true
			},
			{
				Header: 'numberOfAttempt',
				accessor: 'numberOfAttempt',
				filterType: FilterType.float
			}
		],
		[]
	);

	const [defaultFilters, setDefaultFilters] = useState([
		{
			column: columns.find((c) => c.accessor === 'shipmentCreatedDate'),
			action: FilterAction.between,
			value: {
				start: dayjs().startOf('day').toISOString(),
				end: dayjs().endOf('day').toISOString()
			}
		}
	]);

	const applyFilter = (filter) => {
		if (!defaultFilters.map((f) => f.column.accessor).includes(filter.accessor)) {
			setDefaultFilters((prev) => [
				...prev,
				{
					column: columns.find((c) => c.accessor === filter.accessor),
					action: filter.action,
					value: filter.value
				}
			]);
		}
	};

	useEffect(() => {
		if (location?.state?.cardFilter) {
			const analysisTabFilter = location?.state?.analysisFilters;
			if (analysisTabFilter) {
				Object.values(analysisTabFilter).map((filter) => applyFilter(filter));
			}
			applyFilter(location?.state?.cardFilter);
		}
	}, [location.state]);

	return (
		<DynamicList
			id={DYNAMICLISTS.AGGREGATOR_AGING_SHIPMENTS}
			columns={columns}
			defaultFilters={defaultFilters}
			fetchUrl={REPORT.DELIVERY_COMPANY.GET_AGGREGATOR_AGING_LIST}
			exportName="aggregatorAging"
			infiniteScroll
			defaultSort={defaultSort}
		/>
	);
};

export default AggregatorAgingShipments;
